var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useKeyPressEvent } from "react-use";
import { Icon } from "semantic-ui-react";
import Button from "../Semantic/Button";
import { SimpleCard } from "./Card";
import styles from "../../styles/CardList.module.scss";
var CardList = function (_a) {
    var cardMap = _a.cardMap;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    useKeyPressEvent("Escape", function () { return setOpen(false); });
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ onClick: function () { return setOpen(true); } }, { children: "View Cards" }), void 0), _jsxs("div", __assign({ className: styles.listContainer, style: { display: open ? "grid" : "none" } }, { children: [_jsx("button", __assign({ className: styles.closeButton, onClick: function () { return setOpen(false); } }, { children: _jsx(Icon, { name: "close" }, void 0) }), void 0), Object.keys(cardMap).map(function (name) { return (_jsx(SimpleCard, { uid: cardMap[name] }, name)); })] }), void 0)] }, void 0));
};
export default CardList;
